import React from 'react';
import { LegalPage, LegalSection } from '../components/LegalPage';
export function Terms() {
  return <LegalPage title="Terms & Conditions" lastUpdated="7 June 2026" data-id="element-1035">
      <p data-id="element-1036">
        These Terms & Conditions ("Terms") govern your access to and use of the
        Masube Settle website, waitlist, and platform (the "Service") operated
        by Masube Settle (Pty) Ltd. By joining the waitlist or using the
        Service, you agree to these Terms.
      </p>

      <LegalSection heading="1. The waitlist & early access" data-id="element-1037">
        <p data-id="element-1038">
          Joining the waitlist registers your interest in the Service. Access to
          the interactive demo unlocks once 100 retailers have joined. Waitlist
          position, founding-member pricing, and priority onboarding are offered
          at our discretion and may change before general availability.
        </p>
      </LegalSection>

      <LegalSection heading="2. Use of the Service" data-id="element-1039">
        <p data-id="element-1040">
          You agree to use the Service only for lawful purposes and in
          accordance with these Terms. You may not attempt to disrupt,
          reverse-engineer, or gain unauthorised access to any part of the
          Service.
        </p>
      </LegalSection>

      <LegalSection heading="3. Payments & settlement" data-id="element-1041">
        <p data-id="element-1042">
          Where you integrate Masube as a retailer, settlement of collected
          funds occurs via PayShap subject to the rules of the South African
          National Payment System and your separate commercial agreement with
          us. Demonstration data shown on this site is illustrative and does not
          represent real transactions.
        </p>
      </LegalSection>

      <LegalSection heading="4. Intellectual property" data-id="element-1043">
        <p data-id="element-1044">
          All content, branding, and software comprising the Service are owned
          by Masube or its licensors and are protected by applicable
          intellectual-property laws. No rights are granted except as expressly
          set out in a signed agreement.
        </p>
      </LegalSection>

      <LegalSection heading="5. Disclaimers & liability" data-id="element-1045">
        <p data-id="element-1046">
          The waitlist and demo are provided "as is" without warranties of any
          kind. To the maximum extent permitted by law, Masube is not liable for
          any indirect or consequential loss arising from your use of the
          marketing site or demo.
        </p>
      </LegalSection>

      <LegalSection heading="6. Governing law" data-id="element-1047">
        <p data-id="element-1048">
          These Terms are governed by the laws of the Republic of South Africa,
          and any disputes are subject to the exclusive jurisdiction of the
          South African courts.
        </p>
      </LegalSection>

      <LegalSection heading="7. Contact" data-id="element-1049">
        <p data-id="element-1050">
          Questions about these Terms can be sent to{' '}
          <a href="mailto:legal@masube.co.za" className="text-mint hover:underline" data-id="element-1051">
            
            legal@masube.co.za
          </a>
          .
        </p>
      </LegalSection>
    </LegalPage>;
}